"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.match");
var _apolloClient = require("@/apollo/apolloClient");
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _companyMutation = require("@/apollo/mutations/company-mutation");
var _auth = require("@/utils/auth");
var _auth2 = require("../../utils/auth");
var _user = require("@/api/user");
var _v = _interopRequireDefault(require("uuid/v4"));
var _checkExt = require("../../utils/check-ext");
var _validate = require("@/utils/validate");
var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));
var strings = _interopRequireWildcard(require("@/utils/strings"));
var _DateSelect = _interopRequireDefault(require("@/components/DateSelect/DateSelect.vue"));
var _date = require("@/utils/date.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// get token from cookie
var _default = exports.default = {
  components: {
    AffiliationGroup: _AffiliationGroup.default,
    DateSelect: _DateSelect.default
  },
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this;
    var validateRequire = function validateRequire(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を入力してください'));
      } else {
        callback();
      }
    };
    var validateRequireOption = function validateRequireOption(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };
    var checkHanEisu = function checkHanEisu(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }
      if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角英数字で入力してください。'));
      } else {
        if (value.length > 0) {
          if (value.length < rule.minLen) {
            callback(error(rule.colname + 'は' + rule.minLen + '文字以上で入力してください'));
          } else if (value.length > rule.maxLen) {
            callback(error(rule.colname + 'は' + rule.maxLen + '文字以下で入力してください'));
          }
        } else {
          callback(error(rule.colname + 'を入力してください'));
          return;
        }
        callback();
      }
    };
    var checkHanEisuEx = function checkHanEisuEx(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }
      if (_this.$data.form.password !== _this.$data.password_org) {
        if (_this.$data.form.password !== value) {
          callback(error('会員パスワードと会員パスワード（確認用）が異なります。'));
          return;
        }
      }
      callback();
    };
    var error = function error(message) {
      return new Error(message);
    };
    return {
      keyAffiliation: 0,
      title: '',
      drawer: false,
      pathAffiliationList: [],
      createdAffiliation: '',
      passwordType: 'password',
      confirmationPasswordType: 'password',
      pass_check: false,
      disable_password: true,
      disable_confirmed_password: true,
      disable_industries: true,
      company_id: null,
      fileAvatar: [],
      // アバター
      fileAvatarOrg: '',
      phone_number: '',
      password_org: '',
      upload_fax: '',
      upload_mobile: '',
      upload_postcode: '',
      majorName: '',
      space: '　',
      form: {
        uid: '',
        birthday: '',
        company_id: '',
        avatar: '',
        // 会員写真
        full_name: '',
        // 会員名
        full_name_furigana: '',
        // 会員名（ふりがな）
        position: '',
        // 役職名
        mobile_phone: '',
        // 携帯番号
        id: '',
        // ログインID
        password: '',
        // ログインパスワード
        confirmation_password: '',
        is_display: '',
        // アプリへの会員表示の有無
        is_active: '',
        // 会員の管理
        company: {
          id: '',
          // 会社ID
          website: '',
          // ホームページ
          business_descriptions: '',
          // 事業内容
          capital_stock: '',
          // 資本金（任意）
          email: '',
          // E-mail
          employees: '',
          // 社員数（任意）
          employees_part_time: '',
          // パート数（任意）
          established: '',
          // 会社創立年月日
          fax1: '',
          // 会社FAX
          fax2: '',
          // 会社FAX
          fax3: '',
          // 会社FAX
          name: '',
          // 会員企業名
          name_furigana: '',
          // 会員企業名（ふりがな）
          address_1: '',
          // 会社住所
          address_2: '',
          // ビル名
          phone_number1: '',
          // 会社TEL
          phone_number2: '',
          // 会社TEL
          phone_number3: '',
          // 会社TEL
          join_date: '',
          // 入会年月日
          industry: '',
          // 職種コード
          mobile_phone1: '',
          // 携帯番号
          mobile_phone2: '',
          // 携帯番号
          mobile_phone3: '',
          // 携帯番号
          postcode1: '',
          // 会社郵便番号
          postcode2: '',
          // 会社郵便番号
          industries: {
            id: '',
            // 職種ID
            name: '',
            // 職種
            group_id: '',
            // グループID
            code: ''
          },
          created_at: '' // 作成日時
        }
      },
      waitDialogVisible: false,
      updateDialogVisible: false,
      deleteDialogVisible: false,
      companyMode: true,
      period: [{
        scope: ''
      }],
      textOrganization: '',
      textOrganizationShibu: '',
      textOrganizationChiku: '',
      errorMessageOrganization: '',
      checkNumber: function checkNumber(rule, value, callback) {
        if (value === null) {
          callback();
          return;
        }
        if (_this.isNumber(value) === false && value.length > 0) {
          callback(error(rule.colname + 'は半角数字で入力してください'));
        } else {
          callback();
        }
      },
      validateRequire: function validateRequire(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を入力してください'));
        } else {
          callback();
        }
      },
      validateRequirePhone: function validateRequirePhone(rule, value, callback) {
        if (value.length === 0) {
          callback(error(rule.colname + 'を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      tel1: function tel1(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      tel2: function tel2(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      tel3: function tel3(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      postcode1: function postcode1(rule, value, callback) {
        if (_this.isNumber(value) === false) {
          callback(error('郵便番号は、半角数字で入力してください'));
          return;
        }
        if (value.length !== 3) {
          callback(error(rule.colname + '桁数は３桁で入力してください'));
          return;
        }
        callback();
      },
      postcode2: function postcode2(rule, value, callback) {
        if (_this.isNumber(value) === false) {
          callback(error('郵便番号は、半角数字で入力してください'));
          return;
        }
        if (value.length !== 4) {
          callback(error(rule.colname + '桁数は４桁で入力してください'));
          return;
        }
        callback();
      },
      validateRequireFax: function validateRequireFax(rule, value, callback) {
        if (_this.$data.form.company.fax1.length === 0 && _this.$data.form.company.fax2.length === 0 && _this.$data.form.company.fax3.length === 0) {
          _this.$data.upload_fax = (0, _v.default)();
          callback();
          return;
        }
        if (value.length === 0) {
          callback(error(rule.colname + 'に値を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      validateRequireMobile: function validateRequireMobile(rule, value, callback) {
        if (_this.$data.form.company.mobile_phone1.length === 0 && _this.$data.form.company.mobile_phone2.length === 0 && _this.$data.form.company.mobile_phone3.length === 0) {
          _this.$data.upload_mobile = (0, _v.default)();
          callback();
          return;
        }
        if (value.length === 0) {
          callback(error(rule.colname + 'に値を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      checkDate: function checkDate(rule, value, callback) {
        if (value === '' || value === null) {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      validateRequireOption: function validateRequireOption(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      email: function email(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
          return;
        }
        if (!value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }
        callback();
      },
      url: function url(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
          return;
        }
        if (!value.match(/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }
        callback();
      },
      rules: {
        full_name: [{
          required: true,
          validator: validateRequire,
          colname: '会員名'
        }],
        full_name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '会員名（ふりがな）'
        }],
        password: [{
          required: true,
          validator: checkHanEisu,
          colname: '会員パスワード',
          minLen: 4,
          maxLen: 8
        }],
        confirmation_password: [{
          required: true,
          validator: checkHanEisuEx,
          colname: '会員パスワード（確認用）',
          minLen: 4,
          maxLen: 8
        }],
        is_display: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへの会員表示の有無'
        }],
        is_active: [{
          required: true,
          validator: validateRequireOption,
          colname: '会員の管理'
        }]
      }
    };
  },
  computed: {
    // 削除ボタンの表示条件: 会員編集（管理者）時のみ、かつ自分自身は削除不可
    canDelete: function canDelete() {
      return this.companyMode === false && !!this.$data.form.uid && this.$data.form.uid !== (0, _auth2.getCompanyUID)();
    },
    coms: function coms() {
      return this.$store.getters.companies;
    },
    industry_major: function industry_major() {
      return this.$store.getters.industryMajorOptions;
    },
    industry_middle: function industry_middle() {
      return this.$store.getters.industryMiddleOptions;
    },
    industry_info: function industry_info() {
      return this.$store.getters.industryInfo;
    },
    displays: function displays() {
      return this.$store.getters.displayOptions;
    },
    logins: function logins() {
      return this.$store.getters.loginOptions;
    },
    company: function company() {
      return this.$store.getters.company;
    },
    detail: function detail() {
      return this.$store.companyDetail;
    },
    zoneInfo: function zoneInfo() {
      return this.$store.getters.zoneInfo;
    },
    profileSetting: function profileSetting() {
      return this.zoneInfo && this.zoneInfo.profile_setting || {};
    },
    futureTimeCheck: function futureTimeCheck() {
      return {
        disabledDate: function disabledDate(date) {
          return (0, _validate.year_month_day)(date) > (0, _validate.year_month_day)(new Date());
        }
      };
    }
  },
  created: function created() {
    if (this.$store.getters.roles.indexOf('editor') >= 0) {
      this.companyMode = true;
    } else {
      this.companyMode = false;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var hasSearchCondition, ii, phone_numbers, fax_numbers, mobile_phones, postcodes, capital_stock, website, email, userAffilication, pathFromData;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.$store.dispatch('user/GET_USER_DETAIL_INFO_QUERY', (0, _auth2.getCompanyUID)());
          case 1:
            _context.n = 2;
            return this.$store.dispatch('company/getDisplayList');
          case 2:
            _context.n = 3;
            return this.$store.dispatch('company/getLoginList');
          case 3:
            _context.n = 4;
            return this.$store.dispatch('company/getIndustryMajorList');
          case 4:
            hasSearchCondition = !!this.$store.getters.companieSearching || !!this.$store.state.company.majorCode || !!this.$store.state.company.middleCode || this.$store.state.company.pathToListItem.length > 0;
            if (!hasSearchCondition) {
              this.$store.commit('company/pathToListItem', []);
            }
            if (this.companyMode === true) {
              this.$data.disable_industries = true;
            } else {
              this.$data.disable_industries = false;
            }
            if (!(this.companyMode === true)) {
              _context.n = 6;
              break;
            }
            _context.n = 5;
            return this.$store.dispatch('company/fetchCompany', {
              uid: (0, _auth2.getCompanyUID)()
            });
          case 5:
            _context.n = 7;
            break;
          case 6:
            if (this.$route.params.uid !== undefined) {
              (0, _auth2.setEditCompanyCode)(this.$route.params.uid);
            }
            _context.n = 7;
            return this.$store.dispatch('company/fetchCompany', {
              uid: (0, _auth2.getEditCompanyCode)()
            });
          case 7:
            if (!this.$store.getters.member[0].deleted_at) {
              _context.n = 8;
              break;
            }
            this.$notify({
              title: '情報',
              message: 'この会員は削除済みです。',
              type: 'warning',
              duration: 2000
            });
            return _context.a(2, this.$router.push({
              name: 'Company'
            }));
          case 8:
            if (!(this.$store.getters.member[0].company.industry != null)) {
              _context.n = 10;
              break;
            }
            _context.n = 9;
            return this.$store.dispatch('company/getIndustryMiddleList', {
              group_id: this.$store.getters.member[0].company.industries.group_id
            });
          case 9:
            for (ii = 0; ii < this.$store.getters.industryMajorOptions.length; ii++) {
              if (this.$store.getters.industryMajorOptions[ii].id === this.$store.getters.member[0].company.industries.group_id) {
                this.majorName = this.$store.getters.industryMajorOptions[ii].name;
              }
            }
            _context.n = 10;
            return this.$store.dispatch('company/getIndustryMiddleInfo', {
              industry_code: this.$store.getters.member[0].company.industries.code
            });
          case 10:
            if (this.$store.getters.member[0].avatar) {
              this.$data.fileAvatarOrg = this.$store.getters.member[0].avatar;
            }
            phone_numbers = null;
            fax_numbers = null;
            mobile_phones = null;
            postcodes = null;
            capital_stock = '';
            website = '';
            email = '';
            if (this.$store.getters.member[0].company.capital_stock !== 'null') {
              capital_stock = this.$store.getters.member[0].company.capital_stock;
            }
            if (this.$store.getters.member[0].company.postcode !== null) {
              postcodes = this.$store.getters.member[0].company.postcode.split('-');
              if (postcodes.length > 0) {
                this.$data.form.company.postcode1 = postcodes[0];
              }
              if (postcodes.length > 1) {
                this.$data.form.company.postcode2 = postcodes[1];
              }
            } else {
              this.$data.form.company.postcode1 = '';
              this.$data.form.company.postcode2 = '';
            }
            if (this.$store.getters.member[0].company.phone_number !== null) {
              phone_numbers = this.$store.getters.member[0].company.phone_number.split('-');
              if (phone_numbers.length > 0) {
                this.$data.form.company.phone_number1 = phone_numbers[0];
              }
              if (phone_numbers.length > 1) {
                this.$data.form.company.phone_number2 = phone_numbers[1];
              }
              if (phone_numbers.length > 2) {
                this.$data.form.company.phone_number3 = phone_numbers[2];
              }
            } else {
              this.$data.form.company.phone_number1 = '';
              this.$data.form.company.phone_number2 = '';
              this.$data.form.company.phone_number3 = '';
            }
            if (this.$store.getters.member[0].company.fax !== null) {
              fax_numbers = this.$store.getters.member[0].company.fax.split('-');
              if (fax_numbers.length > 0) {
                this.$data.form.company.fax1 = fax_numbers[0];
              }
              if (fax_numbers.length > 1) {
                this.$data.form.company.fax2 = fax_numbers[1];
              }
              if (fax_numbers.length > 2) {
                this.$data.form.company.fax3 = fax_numbers[2];
              }
            } else {
              this.$data.form.company.fax1 = '';
              this.$data.form.company.fax2 = '';
              this.$data.form.company.fax3 = '';
            }
            if (this.$store.getters.member[0].company.mobile_phone !== null) {
              mobile_phones = this.$store.getters.member[0].company.mobile_phone.split('-');
              if (mobile_phones.length > 0) {
                this.$data.form.company.mobile_phone1 = mobile_phones[0];
              }
              if (mobile_phones.length > 1) {
                this.$data.form.company.mobile_phone2 = mobile_phones[1];
              }
              if (mobile_phones.length > 2) {
                this.$data.form.company.mobile_phone3 = mobile_phones[2];
              }
            } else {
              this.$data.form.company.mobile_phone1 = '';
              this.$data.form.company.mobile_phone2 = '';
              this.$data.form.company.mobile_phone3 = '';
            }
            if (this.$store.getters.member[0].company.website === null) {
              website = '';
            } else {
              website = this.$store.getters.member[0].company.website;
            }
            if (this.$store.getters.member[0].company.email === null) {
              email = '';
            } else {
              email = this.$store.getters.member[0].company.email;
            }
            this.$data.form.uid = this.$store.getters.member[0].uid;
            this.$data.form.company_id = this.$store.getters.member[0].company_id;
            this.$data.form.avatar = this.$store.getters.member[0].avatar; // 会員写真
            this.$data.form.full_name = this.$store.getters.member[0].full_name; // 会員名
            this.$data.form.full_name_furigana = this.$store.getters.member[0].full_name_furigana; // 会員名（ふりがな）
            this.$data.form.birthday = this.$store.getters.member[0].birthday; // 生年月日
            this.$data.form.position = this.$store.getters.member[0].position; // 役職名
            this.$data.form.mobile_phone = this.$store.getters.member[0].mobile_phone; // 携帯番号
            this.$data.form.id = this.$store.getters.member[0].id; // ログインID
            this.$data.form.password = (0, _user.decrypt)(this.$store.getters.member[0].password); // ログインパスワード
            this.$data.password_org = (0, _user.decrypt)(this.$store.getters.member[0].password); // ログインパスワード（オリジナル）
            this.$data.form.is_display = this.$store.getters.member[0].is_display; // アプリへの会員表示の有無
            this.$data.form.is_active = this.$store.getters.member[0].is_active; // 会員の管理
            this.$data.form.company.id = this.$store.getters.member[0].company.id; // 会社ID
            this.$data.form.company.website = website; // ホームページ
            this.$data.form.company.business_descriptions = this.$store.getters.member[0].company.business_descriptions; // 事業内容
            this.$data.form.company.capital_stock = capital_stock; // 資本金（任意）
            this.$data.form.company.email = email; // E-mail
            this.$data.form.company.employees = this.$store.getters.member[0].company.employees; // 社員数（任意）
            this.$data.form.company.employees_part_time = this.$store.getters.member[0].company.employees_part_time; // パート（任意）
            this.$data.form.company.established = this.$store.getters.member[0].company.established; // 会社創立年月日
            this.$data.form.company.name = this.$store.getters.member[0].company.name; // 会員企業名
            this.$data.form.company.name_furigana = this.$store.getters.member[0].company.name_furigana; // 会員企業名（ふりがな）
            this.$data.form.company.address_1 = this.$store.getters.member[0].company.address_1; // 会社住所
            this.$data.form.company.address_2 = this.$store.getters.member[0].company.address_2; // ビル名
            this.$data.form.company.join_date = this.$store.getters.member[0].company.join_date; // 入会年月日
            this.$data.form.company.postcode = this.$store.getters.member[0].company.postcode; // 会社郵便番号
            this.$data.form.company.industry = this.$store.getters.member[0].company.industry; // 職種コード
            if (this.$store.getters.member[0].company.industries) {
              this.$data.form.company.industries.id = this.$store.getters.member[0].company.industries.id; // 職種ID
              this.$data.form.company.industries.name = this.$store.getters.member[0].company.industries.name; // 職種名
              this.$data.form.company.industries.code = this.$store.getters.member[0].company.industries.code; // 職種コード
              this.$data.form.company.industries.group_id = this.$store.getters.member[0].company.industries.group_id; // 職種グループID
            }
            this.$data.form.company.companycreated_at = this.$store.getters.member[0].company.companycreated_at; // 作成日時
            // //
            if (!(this.$store.getters.member[0].user_affiliations.length !== 0)) {
              _context.n = 12;
              break;
            }
            userAffilication = this.$store.getters.member[0].user_affiliations;
            _context.n = 11;
            return (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, userAffilication, true);
          case 11:
            pathFromData = _context.v;
            this.pathAffiliationList = pathFromData.sort(function (a, b) {
              return a.idFake - b.idFake;
            });
          case 12:
            this.textOrganization = strings.textChangeByZone().textBranchAreaByZone;
            this.textOrganizationShibu = strings.textChangeByZone().branchMassage;
            this.textOrganizationChiku = strings.textChangeByZone().areaMessage;
          case 13:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    validateJoinDate: function validateJoinDate(rule, value, callback) {
      var dateParts = (0, _date.parseDateString)(value);
      var errorMessage = (0, _date.validateDateParts)(dateParts);
      if (errorMessage) {
        callback(new Error(errorMessage));
        return;
      }
      callback();
    },
    validateEstablished: function validateEstablished(rule, value, callback) {
      var dateParts = (0, _date.parseDateString)(value);
      var errorMessage = (0, _date.validateDateParts)(dateParts, false);
      if (errorMessage) {
        callback(new Error(errorMessage));
        return;
      }
      callback();
    },
    isFieldDisabled: function isFieldDisabled(settingKey) {
      if (!this.companyMode) return false;
      return this.profileSetting[settingKey] === false;
    },
    toCallbackWithErrorAffiliation: function toCallbackWithErrorAffiliation() {
      // / 組織を作成するための条件が満たされていない場合は、エラーを報告してください
      var valueAffiliation = this.pathAffiliationList;
      if (valueAffiliation.length === 0) {
        this.errorMessageOrganization = '組織を選択してください。';
        return true;
      }
      this.errorMessageOrganization = '';
      return false;
    },
    deleteItemAffiliation: function deleteItemAffiliation(item, index) {
      var indexSplice = 1;
      for (var i = index + 1; i < this.pathAffiliationList.length; i++) {
        if (this.pathAffiliationList[i].paddingFloorInTreeAffiliation > item.paddingFloorInTreeAffiliation) {
          indexSplice = indexSplice + 1;
        } else break;
      }
      this.pathAffiliationList.splice(index, indexSplice);
      this.toCallbackWithErrorAffiliation();
    },
    swapAffiliationComponent: function () {
      var _swapAffiliationComponent = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(data) {
        var _this2 = this;
        var listPathOriginalAffiliation, pathFromDepth, setAffiliation;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.drawer = !this.drawer;
              if (this.drawer) this.$store.commit('company/pathToListItem', []);else this.keyAffiliation++;
              listPathOriginalAffiliation = this.$store.getters.pathToListItem;
              if (!(listPathOriginalAffiliation.length !== 0 && listPathOriginalAffiliation && this.drawer === false)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, listPathOriginalAffiliation);
            case 1:
              pathFromDepth = _context2.v;
              if (this.pathAffiliationList.length !== 0) {
                setAffiliation = pathFromDepth.filter(function (val) {
                  return _this2.pathAffiliationList.some(function (entire) {
                    return val.id === entire.id;
                  }) === false;
                });
                if (setAffiliation.length !== 0) setAffiliation.forEach(function (item) {
                  return _this2.pathAffiliationList.push(item);
                });
              } else this.pathAffiliationList = pathFromDepth;
              this.pathAffiliationList.sort(function (a, b) {
                return a.idFake - b.idFake;
              });
              // / 組織を選択するときに通知を表示または非表示にする
              this.toCallbackWithErrorAffiliation();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function swapAffiliationComponent(_x) {
        return _swapAffiliationComponent.apply(this, arguments);
      }
      return swapAffiliationComponent;
    }(),
    activePwd: function activePwd() {
      this.pass_check = !this.pass_check;
      if (this.pass_check === true) {
        this.disable_password = false;
        this.disable_confirmed_password = false;
        this.$data.form.password = '';
        this.$data.form.confirmation_password = '';
      } else {
        this.disable_password = true;
        this.disable_confirmed_password = true;
      }
    },
    showPwd: function showPwd() {
      var _this3 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this3.$refs.password.focus();
      });
    },
    showConfirmationPwd: function showConfirmationPwd() {
      var _this4 = this;
      if (this.confirmationPasswordType === 'password') {
        this.confirmationPasswordType = '';
      } else {
        this.confirmationPasswordType = 'password';
      }
      this.$nextTick(function () {
        _this4.$refs.confirmationPassword.focus();
      });
    },
    changeIndustryMajor: function () {
      var _changeIndustryMajor = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.$store.dispatch('company/getIndustryMiddleList', {
                group_id: this.$data.form.company.industries.group_id
              });
            case 1:
              this.$data.form.company.industry = this.$store.getters.industryMiddleOptions[0].code;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function changeIndustryMajor() {
        return _changeIndustryMajor.apply(this, arguments);
      }
      return changeIndustryMajor;
    }(),
    getExtension: function getExtension(fileName) {
      var ret;
      if (!fileName) {
        return ret;
      }
      var fileTypes = fileName.split('.');
      var len = fileTypes.length;
      if (len === 0) {
        return ret;
      }
      ret = fileTypes[len - 1];
      return ret;
    },
    handleRemoveAvatar: function handleRemoveAvatar(file, fileList) {
      this.log('handleRemoveAvatar');
      this.fileAvatar = fileList;
    },
    handleDeleteAvatar: function handleDeleteAvatar(file, fileList) {
      this.log('handleDeleteAvatar');
      this.fileAvatarOrg = '';
    },
    handleAddAvatar: function handleAddAvatar(file, fileList) {
      this.log('handleAddAvatar');
      if ((0, _checkExt.checkExtImage)(file.name)) {
        this.fileAvatar = fileList;
      } else {
        this.fileAvatar = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 2000
        });
      }
    },
    // 会員を論理削除（退会）する。Firebase Auth の無効化は Hasura のイベントトリガー経由で Cloud Functions が行う。
    onDelete: function () {
      var _onDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var res, affectedRows, _t;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.deleteDialogVisible = false;
              this.waitDialogVisible = true;
              _context4.p = 1;
              _context4.n = 2;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.DELETE_MEMBER,
                variables: {
                  uid: this.$data.form.uid
                }
              });
            case 2:
              res = _context4.v;
              affectedRows = res.data.update_user.affected_rows;
              if (affectedRows === 0) {
                this.$notify({
                  title: '情報',
                  message: 'この会員は既に削除されています。',
                  type: 'warning',
                  duration: 2000
                });
              } else {
                this.$notify({
                  title: '情報',
                  message: '会員を削除しました。',
                  type: 'success',
                  duration: 2000
                });
              }
              this.waitDialogVisible = false;
              return _context4.a(2, this.$router.push({
                name: 'Company'
              }));
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              this.waitDialogVisible = false;
              this.log(_t);
              this.$notify({
                title: '情報',
                message: '会員の削除に失敗しました。',
                type: 'error',
                duration: 2000
              });
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function onDelete() {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    postFromCheck: function postFromCheck() {
      var _this5 = this;
      this.log(this.form);
      // エラーが発生した場合は停止します
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this5.toCallbackWithErrorAffiliation()) return;
          _this5.updateDialogVisible = true;
        } else {
          _this5.toCallbackWithErrorAffiliation();
          _this5.log('error submit!!');
          return false;
        }
      });
    },
    onUpdate: function () {
      var _onUpdate = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var _this6 = this;
        var fileAvatarURL, employees, employees_part_time, establishedValue, established, is_birthday, join_date, objects, hasErrorUpdate, objectsAffilication, listAffiliationId;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.waitDialogVisible = true;
              this.updateDialogVisible = false;
              // アバターの保存
              fileAvatarURL = null;
              if (!(this.fileAvatar.length > 0)) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return this.uploadFileToStorage(this.fileAvatar[0].raw, 'users/avatar/avatar_' + this.$store.getters.member[0].uid + '.jpg');
            case 1:
              fileAvatarURL = _context5.v;
              if (!(fileAvatarURL == null)) {
                _context5.n = 2;
                break;
              }
              console.log('画像のアップロードに失敗しました。');
              this.waitDialogVisible = false;
              return _context5.a(2);
            case 2:
              if (this.fileAvatarOrg) {
                if (this.fileAvatarOrg && !fileAvatarURL) {
                  // 画像の変更無し
                  fileAvatarURL = this.fileAvatarOrg;
                }
              }
              employees = 0;
              if (this.$data.form.company.employees === '' || this.$data.form.company.employees === null || this.$data.form.company.employees === undefined) {
                employees = null;
              } else {
                employees = this.$data.form.company.employees;
              }
              employees_part_time = 0;
              if (this.$data.form.company.employees_part_time === '' || this.$data.form.company.employees_part_time === null || this.$data.form.company.employees_part_time === undefined) {
                employees_part_time = null;
              } else {
                employees_part_time = this.$data.form.company.employees_part_time;
              }
              establishedValue = String(this.$data.form.company.established || '').trim();
              established = establishedValue || null;
              is_birthday = null;
              if (this.$data.form.birthday) {
                is_birthday = new Date(this.$data.form.birthday).toLocaleString({
                  timeZone: 'Asia/Tokyo'
                });
              }
              join_date = String(this.$data.form.company.join_date || '').trim();
              if (join_date) {
                _context5.n = 3;
                break;
              }
              this.waitDialogVisible = false;
              this.$notify({
                title: 'エラー',
                message: '入会年月は必須です。',
                type: 'error',
                duration: 2000
              });
              return _context5.a(2);
            case 3:
              objects = {};
              if (this.pass_check === true) {
                objects = {
                  avatar: fileAvatarURL,
                  full_name: this.$data.form.full_name,
                  full_name_furigana: this.$data.form.full_name_furigana,
                  birthday: is_birthday,
                  position: this.$data.form.position,
                  mobile_phone: this.$data.form.mobile_phone,
                  password: (0, _user.encrypt)(this.$data.form.password),
                  is_display: this.$data.form.is_display,
                  is_active: this.$data.form.is_active
                };
              } else {
                objects = {
                  avatar: fileAvatarURL,
                  full_name: this.$data.form.full_name,
                  full_name_furigana: this.$data.form.full_name_furigana,
                  birthday: is_birthday,
                  position: this.$data.form.position,
                  mobile_phone: this.$data.form.mobile_phone,
                  is_display: this.$data.form.is_display,
                  is_active: this.$data.form.is_active
                };
              }
              if (!fileAvatarURL) {
                objects.avatar_thumbnail = null;
              }
              hasErrorUpdate = false;
              _context5.n = 4;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.UPDATE_MEMBER,
                variables: {
                  uid: this.$data.form.uid,
                  objects: objects
                }
              }).catch(function (error) {
                _this6.$notify({
                  title: '情報',
                  message: '会員情報の更新に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.waitDialogVisible = false;
                _this6.log(error);
                hasErrorUpdate = true;
                return;
              });
            case 4:
              objectsAffilication = [];
              listAffiliationId = [];
              if (!(this.pathAffiliationList.length !== 0 && this.companyMode === false)) {
                _context5.n = 5;
                break;
              }
              this.pathAffiliationList.map(function (item) {
                listAffiliationId.push(item.id);
                objectsAffilication.push({
                  affiliation_id: item.id,
                  user_id: _this6.$data.form.uid
                });
              });
              _context5.n = 5;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.USER_AFFILIATION_INSERT_UPDATE,
                variables: {
                  user_id: this.$data.form.uid,
                  affiliation_ids: listAffiliationId,
                  objects: objectsAffilication
                }
              }).catch(function (error) {
                _this6.$notify({
                  title: '情報',
                  message: '組織の更新に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.waitDialogVisible = false;
                console.log(error);
                hasErrorUpdate = true;
                return;
              });
            case 5:
              if (!(this.companyMode === false)) {
                _context5.n = 7;
                break;
              }
              _context5.n = 6;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.UPDATE_COMPANY_ADMIN,
                variables: {
                  id: this.$data.form.company.id,
                  name: this.$data.form.company.name,
                  name_furigana: this.$data.form.company.name_furigana,
                  phone_number: this.$data.form.company.phone_number1 + '-' + this.$data.form.company.phone_number2 + '-' + this.$data.form.company.phone_number3,
                  mobile_phone: this.$data.form.company.mobile_phone1 + '-' + this.$data.form.company.mobile_phone2 + '-' + this.$data.form.company.mobile_phone3,
                  fax: this.$data.form.company.fax1 + '-' + this.$data.form.company.fax2 + '-' + this.$data.form.company.fax3,
                  email: this.$data.form.company.email,
                  website: this.$data.form.company.website,
                  postcode: this.$data.form.company.postcode1 + '-' + this.$data.form.company.postcode2,
                  address_1: this.$data.form.company.address_1,
                  address_2: this.$data.form.company.address_2,
                  business_descriptions: this.$data.form.company.business_descriptions,
                  capital_stock: this.$data.form.company.capital_stock,
                  employees: employees,
                  employees_part_time: employees_part_time,
                  established: established,
                  join_date: join_date,
                  industry: this.$data.form.company.industry
                }
              }).catch(function (error) {
                _this6.$notify({
                  title: '情報',
                  message: '会員情報の更新に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.waitDialogVisible = false;
                _this6.log(error);
                hasErrorUpdate = true;
                return;
              });
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.n = 8;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.UPDATE_COMPANY,
                variables: {
                  id: this.$data.form.company.id,
                  name: this.$data.form.company.name,
                  name_furigana: this.$data.form.company.name_furigana,
                  phone_number: this.$data.form.company.phone_number1 + '-' + this.$data.form.company.phone_number2 + '-' + this.$data.form.company.phone_number3,
                  mobile_phone: this.$data.form.company.mobile_phone1 + '-' + this.$data.form.company.mobile_phone2 + '-' + this.$data.form.company.mobile_phone3,
                  fax: this.$data.form.company.fax1 + '-' + this.$data.form.company.fax2 + '-' + this.$data.form.company.fax3,
                  email: this.$data.form.company.email,
                  website: this.$data.form.company.website,
                  postcode: this.$data.form.company.postcode1 + '-' + this.$data.form.company.postcode2,
                  address_1: this.$data.form.company.address_1,
                  address_2: this.$data.form.company.address_2,
                  business_descriptions: this.$data.form.company.business_descriptions,
                  capital_stock: this.$data.form.company.capital_stock,
                  employees: employees,
                  established: established,
                  join_date: join_date
                }
              }).catch(function (error) {
                _this6.$notify({
                  title: '情報',
                  message: '会員情報の更新に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.waitDialogVisible = false;
                _this6.log(error);
                hasErrorUpdate = true;
                return;
              });
            case 8:
              if (!(hasErrorUpdate === false)) {
                _context5.n = 9;
                break;
              }
              this.$notify({
                title: '情報',
                message: '会員情報の更新が完了しました。',
                type: 'success',
                duration: 2000
              });
              this.waitDialogVisible = false;
              if (!((0, _auth.getToken)() === 'admin-token')) {
                _context5.n = 9;
                break;
              }
              return _context5.a(2, this.$router.push({
                name: 'Company'
              }));
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onUpdate() {
        return _onUpdate.apply(this, arguments);
      }
      return onUpdate;
    }(),
    isNumber: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    },
    isHanEisu: function isHanEisu(str) {
      str = str === null ? '' : str;
      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },
    log: function log(text) {}
  }
};